import { useEffect, useState, useRef } from 'react';
import WealthPackages from './WealthPackages';
import { fetchData } from './Helpers';
import { tickImg, crossImg, resolveImage } from "../../images/ImageResolver";


function transformedData(data, filterType){
  let tData = data.map(row => ({
    name: row.segment,
    public: row.public,
    private: row.private,
    advanced: row.advanced,
    professional: row.professional,
    category: row.category,
    type: row.estimateType
  }))
  return tData.filter(item => item.type.trim() === filterType)
}


function AllEstimates() {
  const [wealth, setWealth] = useState(false);
  const [measuresData, setMeasuresData] = useState([]);
  const [hsData, setHsData] = useState([]);
  const [pData, setPData] = useState([]);
  const [npData, setNPData] = useState([]);
  const [rData, setRData] = useState([]);
  const [aData, setAData] = useState([]);
  const sumData = useRef(null);
  const [tableFlag, setTableFlag] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData("All_Estimates_Data_Items").then((res) => {
      setMeasuresData(transformedData(res, "Measures"));
      setHsData(transformedData(res, "Historical Snapshot"));
      setPData(transformedData(res, "Summary Fields Periodic Estimates Measures"));
      setNPData(transformedData(res, "Summary Fields Non-Periodic Estimates Measures"));
      setRData(transformedData(res, "Summary Reccomendations"));
      setAData(transformedData(res, "Actuals"));
      let d = res.filter(item => item.segment.trim() === "Number of Measures in package")[0];
      d["name"] = d["segment"]
      sumData.current = d;
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const mgrid = document.getElementById('measuresGrid');
    const hsgrid = document.getElementById('hsGrid');
    const pgrid = document.getElementById('pGrid');
    const npgrid = document.getElementById('npGrid');
    const rgrid = document.getElementById('rGrid');
    const agrid = document.getElementById('aGrid');
    const styles = {
      "background-color":"#fafaff",
      textAlign: "center"
    };
    const styles2 = {
      textAlign: "center",
    };

    const hsColumns = [
      { name: 'Measures', field: 'name', width:2.5, scalable: true},
      { name: 'PUBLIC', field: 'public', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "Free to air", "free"), binding: textWithIcon, styles: styles },
      { name: 'PRIVATE', field: 'private', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "private"), binding: textWithIcon, styles: styles2 },
      { name: 'ADVANCED', field: 'advanced', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "advanced"), binding: textWithIcon, styles: styles },
      { name: 'PROFESSIONAL', field: 'professional', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "professional"), binding: textWithIcon, styles: styles2 }
    ]

    function getCoulmns(cname){
      let columns = [
        { name: cname, field: 'name', width:2.5, scalable: true},
        { name: 'PUBLIC', field: 'public', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "Free to air", "free"), binding: textWithIcon, styles: styles },
        { name: 'PRIVATE', field: 'private', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "private"), binding: textWithIcon, styles: styles2 },
        { name: 'ADVANCED', field: 'advanced', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "advanced"), binding: textWithIcon, styles: styles },
        { name: 'PROFESSIONAL', field: 'professional', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "professional"), binding: textWithIcon, styles: styles2 },
        { name: 'Category', field: 'category', width: 1.5, scalable: true, styles: styles, binding: textWithLink, },
      ]
      return columns
    }

    function getCoulmns2(cname){
      let columns = [
        { name: cname, field: 'name', width:2.5, scalable: true},
        { name: 'PUBLIC', field: 'public', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "Free to air", "free"), binding: textWithIcon, styles: styles },
        { name: 'PRIVATE', field: 'private', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "private"), binding: textWithIcon, styles: styles2 },
        { name: 'ADVANCED', field: 'advanced', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "advanced"), binding: textWithIcon, styles: styles },
        { name: 'PROFESSIONAL', field: 'professional', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "PW Protected", "professional"), binding: textWithIcon, styles: styles2 }
      ]
      return columns
    }

    function textWithIcon(e) {
      let cell = e.cell; 
      let content = cell.getContent();
      if (!content) {
        content = document.createElement("div");
        content.className = 'icon-cell';
        content.style.textAlign = "center";
        
        let img = document.createElement("img");
        img.className = 'icon-cell__img';
        img.width = 16;     // tweak as needed
        img.height = 16;    // tweak as needed
        img.decoding = 'async';
        img.loading = 'eager';
        content.appendChild(img);

        let span = document.createElement("span");
        span.textContent = e.data;
        if(!isNaN(e.data) && Number(e.data) > 0){
          content.appendChild(span);
        }

        cell.setContent(content);
      }

      const value = String(e.data).toLowerCase();
      const imgEl = content.querySelector('.icon-cell__img');
      imgEl.src = (value === 'x') ? tickImg : crossImg;
      if(!isNaN(e.data) && Number(e.data) > 0){
        imgEl.style.display = "none";
      }

    }

    function textWithLink(e) {
      let cell = e.cell;
      let content = cell.getContent();
      if (!content) {
        content = document.createElement("div");
        content.style.textAlign = "center";
        let link = document.createElement("label");
        link.style.color = "#001EFF";
        link.style.textDecoration = "underline";
        link.textContent = e.data;
        link.style.cursor = "pointer";
        if(e.data === "Periodic"){
          link.addEventListener("click", function(arg) {
            arg.stopPropagation();
            setTableFlag(1);
          });
        }else if(e.data === "Non-Periodic"){
          link.addEventListener("click", function(arg) {
            arg.stopPropagation();
            setTableFlag(2);
          });
        }else if(e.data === "Recommendation"){
          link.addEventListener("click", function(arg) {
            arg.stopPropagation();
            setTableFlag(3);
          });
        }else if(e.data === "Measures"){
          link.addEventListener("click", function(arg) {
            arg.stopPropagation();
            setTableFlag(0);
          });
        }
        content.appendChild(link);
      }
      cell.setContent(content);
    }

    function headerWithLink(text, i, e) {
      let cell = e.cell;
      let content = cell.getContent();
      if(!content || !content._myHeaderWithLink) {
        content = document.createElement("div");
        content._myHeaderWithLink = true;
        let span = content._span = document.createElement("span");
        span.style.marginRight = "5px";
        let link = content._link = document.createElement("ef-icon");
        link.icon = "link";
        content.addEventListener("click", function(arg) {
          arg.stopPropagation();
          // alert("Icon clicked");
					setWealth(true);
        });
        let image = content._span1 = document.createElement("img");
        image.style.position = "absolute";
        image.style.top = "10px";
        image.style.right = "5px";
        image.style.width = "38px";
        image.src = resolveImage(i);
        let span2 = content._span2 = document.createElement("span");
        span2.style.display = "block";
        span2.style.fontWeight = 400;
        content.appendChild(span);
        content.appendChild(link);
        content.appendChild(span2);
        content.appendChild(image);
      }

      content._span.textContent = e.columnDef.getName();
      content._span2.textContent = text;
      cell.setContent(content);
    };
    if(!wealth){
      if(tableFlag === 0){
        mgrid.config = {
          rowHeight: 60,
          headerRowHeight: 60,
          columns: getCoulmns("Measures"),
          dataModel: {
            data: measuresData
          }
        };
        setTimeout(() => {
            mgrid.api.insertRow({ values: sumData.current });
        }, 1000);
        mgrid.addEventListener('rendered', {});
        hsgrid.config = {
          rowHeight: 60,
          headerRowHeight: 60,
          columns: hsColumns,
          dataModel: {
            data: hsData
          }
        };
      }else if(tableFlag === 1){
        pgrid.config = {
          rowHeight: 60,
          headerRowHeight: 60,
          columns: getCoulmns2("Summary Fields Periodic Estimates Measures"),
          dataModel: {
            data: pData
          }
        };
        agrid.config = {
          rowHeight: 60,
          headerRowHeight: 60,
          columns: getCoulmns2("Actuals"),
          dataModel: {
            data: aData
          }
        };
      }else if(tableFlag === 2){
        npgrid.config = {
          rowHeight: 60,
          headerRowHeight: 60,
          columns: getCoulmns2("Summary Fields Non-Periodic Estimates Measures"),
          dataModel: {
            data: npData
          }
        };
      }else if(tableFlag === 3){
        rgrid.config = {
          rowHeight: 60,
          headerRowHeight: 60,
          columns: getCoulmns2("Summary Reccomendations"),
          dataModel: {
            data: rData
          }
        };
      }
    }
  }, [measuresData, hsData, pData, npData, rData, tableFlag, aData, wealth]);

  return (
    <div className='main-div'>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
			{wealth && (
        <div>
          <ef-button className="back-button" icon="back" onClick={() => setWealth(false)}>Back</ef-button>
          <WealthPackages />
        </div>
      )}
			{!wealth && (
			<div>
      <h4>SEGMENTATION FOR ESTIMATES IN COMPANY SNAPSHOT API</h4>
				<p>Clients may subscribe for regional or global packages. Clients are responsible for limiting their use of content to the regions they are licensed for and the segmentation for estimates measures and data fields as outlined in this data guide.</p>
				{ tableFlag !== 0 && <ef-button className="back-button" onClick={() => setTableFlag(0)}><ef-icon icon="back"></ef-icon> Back to measures</ef-button>}
        <ef-layout flex style={{ marginTop: '20px' }}>
					<ef-layout>
          { tableFlag !== 0 && 
						<ef-tab-bar>
              <ef-tab label="Periodic" value="Periodic" onClick={() => setTableFlag(1)}></ef-tab>
              <ef-tab label="Non-Periodic" value="Non-Periodic" onClick={() => setTableFlag(2)}></ef-tab>
              <ef-tab label="Recommendations" value="Recommendations" onClick={() => setTableFlag(3)}></ef-tab>
            </ef-tab-bar>
          }
					</ef-layout>
				</ef-layout>
				
        { tableFlag === 0 && (
          <div>
            <efx-grid id="measuresGrid" className="estimates-grid"></efx-grid>
            <efx-grid id="hsGrid" className="estimates-grid"></efx-grid>
          </div>
        )}
				
        { tableFlag === 1 && (
          <div>
            <efx-grid id="pGrid" className="estimates-grid"></efx-grid>
            <efx-grid id="aGrid" className="estimates-grid"></efx-grid>
          </div>
          )}
        { tableFlag === 2 && <efx-grid id="npGrid" className="estimates-grid"></efx-grid>}
        { tableFlag === 3 && <efx-grid id="rGrid" className="estimates-grid"></efx-grid>}
			</div>
			)}
    </div>
  );
}

export default AllEstimates;
